<div class="flex flex-col justify-between py-8 px-6 md:px-8 gap-4">

  <span>You do not have permissions to access this page.</span>
</div>
